import { render, staticRenderFns } from "./FallingItem.vue?vue&type=template&id=410d625b&scoped=true&"
import script from "./FallingItem.vue?vue&type=script&lang=js&"
export * from "./FallingItem.vue?vue&type=script&lang=js&"
import style0 from "./FallingItem.vue?vue&type=style&index=0&id=410d625b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410d625b",
  null
  
)

export default component.exports